/**
 * Ashrama Vashita D40 Color Configuration
 * Colors for 4 ASHRAMA (life stages) and 10 VASHITA (influences)
 */

import { AshramaType, VashitaType } from '../components/common/AstrologyChart/DataSections/data/AshramaVashitaTableData';

/**
 * Color configuration for 4 ASHRAMA (life stages)
 * Gradient from youth (green) to renunciation (purple)
 */
export const ASHRAMA_COLORS: Record<AshramaType, string> = {
  BRAHMACHARYA: '#10b981',  // Student - Green (youth, learning)
  GRIHASTHA: '#f59e0b',     // Householder - Amber (active life)
  VANAPRASTHA: '#3b82f6',   // Retirement - Blue (wisdom, teaching)
  SANYASA: '#9333ea'        // Renunciation - Purple (spiritual)
};

/**
 * Color configuration for 10 VASHITA (spheres of influence)
 * Varied colors for different life aspects
 */
export const VASHITA_COLORS: Record<VashitaType, string> = {
  JANA: '#64748b',        // Origin - Slate
  JANMA: '#0891b2',       // Birth - Cyan
  AYUS: '#059669',        // Longevity - Emerald
  CHITTA: '#7c3aed',      // Consciousness - Violet
  PARISHKURA: '#db2777',  // Creativity - Pink
  DHARMA: '#ea580c',      // Purpose - Orange
  RIDDHI: '#ca8a04',      // Prosperity - Yellow
  PRANIDHANA: '#dc2626',  // Overcoming - Red
  KARMA: '#4f46e5',       // Activity - Indigo
  ADHI_MUKTI: '#16a34a'   // Confidence - Green
};

/**
 * Get color for ASHRAMA type
 */
export function getAshramaColor(ashramaType: AshramaType): string {
  return ASHRAMA_COLORS[ashramaType] || ASHRAMA_COLORS.BRAHMACHARYA;
}

/**
 * Get color for VASHITA type
 */
export function getVashitaColor(vashitaType: VashitaType): string {
  return VASHITA_COLORS[vashitaType] || VASHITA_COLORS.JANA;
}
